// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.action-container {
    background-color: #150924;
    color: #fff;
    padding: 50px 0px 100px;
    text-align: center;
}

.action-container .title {
    text-align: center;
    color: #FFF;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: 34px;
    margin-bottom: 30px;
    font-family: "Inter", sans-serif;
}

.action-container .highlight {
    background-color: #A855F7;
    color: #fff;
    padding: 5px;
}

.action-container .description {
    color: #FFF;
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 34px;
    max-width: 905px;
    margin: 0 auto;
    padding-bottom: 90px;
}

.action-container .sub-title {
    color: #FFF;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 34px;
    margin-bottom: 86px;
}

.action-container .steps-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;

}

.action-container .steps-wrapper-mob {
    display: none;
}


.action-container .steps-row {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    margin-left: -8%;
}

.action-container .bottom-row {
    margin-top: 50px;
    margin-left: 8%;
}

.action-container .step-item {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.action-container .circle {
    width: 60px;
    height: 60px;
    background-color: #14B8A6;
    color: #fff;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.5em;
    position: relative;
    z-index: 1;
    box-shadow: 0 0 0 10px #18122B;
}

.action-container .circle::after {
    content: '';
    position: absolute;
    top: -6px;
    left: -6px;
    right: -6px;
    bottom: -6px;
    border: 2px dashed #14B8A6;
    border-radius: 50%;
    z-index: -1;
}

.action-container .connector {
    width: 300px;
    height: 2px;
    background: repeating-linear-gradient(90deg, #14B8A6, #14B8A6 5px, transparent 5px, transparent 10px);

}

.action-container .before-connector {
    width: 50px;
    height: 2px;
    background: repeating-linear-gradient(90deg, #14B8A6, #14B8A6 5px, transparent 5px, transparent 10px);

}

.action-container .steps-description {
    display: flex;
    justify-content: space-around;
    margin-top: 10px;
}

.action-container .desription-wrap {
    min-width: 350px;
    max-width: 350px;
}

.action-container .step-desc {
    max-width: 300px;
    font-size: 1em;
    line-height: 1.5;
    margin: 0 auto;
}

@media (max-width: 768px) {
    .action-container {
        padding: 20px;
    }

    .action-container .title {
        font-size: 25px;
    }

    .action-container .description {
        font-size: 15px;
        line-height: 19px;
        padding: 28px 20px 20px;
    }

    .action-container .sub-title {
        font-size: 12px;
        line-height: 34px;
        margin-bottom: 20px;
    }

    .action-container .steps-wrapper {
        display: none;

    }

    .action-container .steps-wrapper-mob {
        display: block;
    }

    .step-content-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0px 42px;
        margin-bottom: 38px;
    }

    .steps-wrapper-mob .step-number {
        width: 60px;
        height: 60px;
        background-color: #14B8A6;
        color: #fff;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.5em;
        position: relative;
        z-index: 1;
        box-shadow: 0 0 0 10px #18122B;
    }

    .steps-wrapper-mob .step-number::after {
        content: '';
        position: absolute;
        top: -6px;
        left: -6px;
        right: -6px;
        bottom: -6px;
        border: 2px dashed #14B8A6;
        border-radius: 50%;
        z-index: -1;
    }

    .steps-wrapper-mob .step-description {
        color: #FFF;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 19px;
        padding-top: 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Action/Action.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,WAAW;IACX,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;;AAEvB;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,qGAAqG;;AAEzG;;AAEA;IACI,WAAW;IACX,WAAW;IACX,qGAAqG;;AAEzG;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,aAAa;;IAEjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,yBAAyB;QACzB,WAAW;QACX,kBAAkB;QAClB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,gBAAgB;QAChB,kBAAkB;QAClB,UAAU;QACV,8BAA8B;IAClC;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,SAAS;QACT,UAAU;QACV,WAAW;QACX,YAAY;QACZ,0BAA0B;QAC1B,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,iBAAiB;IACrB;AACJ","sourcesContent":[".action-container {\n    background-color: #150924;\n    color: #fff;\n    padding: 50px 0px 100px;\n    text-align: center;\n}\n\n.action-container .title {\n    text-align: center;\n    color: #FFF;\n    font-size: 32px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 34px;\n    margin-bottom: 30px;\n    font-family: \"Inter\", sans-serif;\n}\n\n.action-container .highlight {\n    background-color: #A855F7;\n    color: #fff;\n    padding: 5px;\n}\n\n.action-container .description {\n    color: #FFF;\n    text-align: center;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 34px;\n    max-width: 905px;\n    margin: 0 auto;\n    padding-bottom: 90px;\n}\n\n.action-container .sub-title {\n    color: #FFF;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 34px;\n    margin-bottom: 86px;\n}\n\n.action-container .steps-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n}\n\n.action-container .steps-wrapper-mob {\n    display: none;\n}\n\n\n.action-container .steps-row {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 20px;\n    margin-left: -8%;\n}\n\n.action-container .bottom-row {\n    margin-top: 50px;\n    margin-left: 8%;\n}\n\n.action-container .step-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.action-container .circle {\n    width: 60px;\n    height: 60px;\n    background-color: #14B8A6;\n    color: #fff;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 1.5em;\n    position: relative;\n    z-index: 1;\n    box-shadow: 0 0 0 10px #18122B;\n}\n\n.action-container .circle::after {\n    content: '';\n    position: absolute;\n    top: -6px;\n    left: -6px;\n    right: -6px;\n    bottom: -6px;\n    border: 2px dashed #14B8A6;\n    border-radius: 50%;\n    z-index: -1;\n}\n\n.action-container .connector {\n    width: 300px;\n    height: 2px;\n    background: repeating-linear-gradient(90deg, #14B8A6, #14B8A6 5px, transparent 5px, transparent 10px);\n\n}\n\n.action-container .before-connector {\n    width: 50px;\n    height: 2px;\n    background: repeating-linear-gradient(90deg, #14B8A6, #14B8A6 5px, transparent 5px, transparent 10px);\n\n}\n\n.action-container .steps-description {\n    display: flex;\n    justify-content: space-around;\n    margin-top: 10px;\n}\n\n.action-container .desription-wrap {\n    min-width: 350px;\n    max-width: 350px;\n}\n\n.action-container .step-desc {\n    max-width: 300px;\n    font-size: 1em;\n    line-height: 1.5;\n    margin: 0 auto;\n}\n\n@media (max-width: 768px) {\n    .action-container {\n        padding: 20px;\n    }\n\n    .action-container .title {\n        font-size: 25px;\n    }\n\n    .action-container .description {\n        font-size: 15px;\n        line-height: 19px;\n        padding: 28px 20px 20px;\n    }\n\n    .action-container .sub-title {\n        font-size: 12px;\n        line-height: 34px;\n        margin-bottom: 20px;\n    }\n\n    .action-container .steps-wrapper {\n        display: none;\n\n    }\n\n    .action-container .steps-wrapper-mob {\n        display: block;\n    }\n\n    .step-content-wrapper {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        padding: 0px 42px;\n        margin-bottom: 38px;\n    }\n\n    .steps-wrapper-mob .step-number {\n        width: 60px;\n        height: 60px;\n        background-color: #14B8A6;\n        color: #fff;\n        border-radius: 50%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 1.5em;\n        position: relative;\n        z-index: 1;\n        box-shadow: 0 0 0 10px #18122B;\n    }\n\n    .steps-wrapper-mob .step-number::after {\n        content: '';\n        position: absolute;\n        top: -6px;\n        left: -6px;\n        right: -6px;\n        bottom: -6px;\n        border: 2px dashed #14B8A6;\n        border-radius: 50%;\n        z-index: -1;\n    }\n\n    .steps-wrapper-mob .step-description {\n        color: #FFF;\n        text-align: center;\n        font-size: 15px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 19px;\n        padding-top: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
